(() => {
  if (!["/apps/gbb/easybundle/9", "/apps/gbb/easybundle/11", "/apps/gbb/easybundle/13"].includes(location.pathname)) return;

  const normalize = text => text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

  function translateBundleFooter() {
    const title = document.querySelector(".gbbFooterBundleTitle");
    const subtext = document.querySelector(".gbbFooterBundleSubtext");

    if (title && title.textContent.trim() === "Your Bundle") title.textContent = "Tu pack";
    if (subtext && subtext.textContent.trim() === "Review your bundle") subtext.textContent = "Revisa tu pack";
  }

  function formatPrices() {
    document.querySelectorAll([
      ".gbbProductItemPrice",
      ".gbbProductItemCompareAtPrice",
      ".gbbFooterTotalValue"
    ].join(",")).forEach(element => {
      const original = element.textContent.trim();
      if (!/^\$\s*[\d.,]+$/.test(original)) return;

      const number = original.replace(/^\$\s*/, "").replace(/[.,]00$/, "").replace(/\D/g, "");
      if (number) element.textContent = "$" + Number(number).toLocaleString("es-CL");
    });
  }

  function addSearch() {
    if (document.querySelector(".samsa-bundle-search")) return;

    const products = document.querySelector(".gbbProductsContainer");
    if (!products) return;

    const search = document.createElement("div");
    search.className = "samsa-bundle-search";
    search.innerHTML = `
      <input type="search"
        placeholder="Buscar aroma..."
        aria-label="Buscar aroma"
        autocomplete="off">
      <p class="samsa-bundle-empty">No encontramos aromas con ese nombre.</p>
    `;

    products.parentNode.insertBefore(search, products);

    const input = search.querySelector("input");
    const empty = search.querySelector(".samsa-bundle-empty");

    input.addEventListener("input", () => {
      const term = normalize(input.value);
      let results = 0;

      document.querySelectorAll(".gbbProductItem").forEach(card => {
        const title = card.querySelector(".gbbProductItemTitle")?.textContent || "";
        const visible = !term || normalize(title).includes(term);

        card.style.display = visible ? "" : "none";
        if (visible) results++;
      });

      empty.style.display = term && !results ? "block" : "none";
    });
  }

  function addStyles() {
    if (document.querySelector("#samsa-bundle-tools-style")) return;

    const style = document.createElement("style");
    style.id = "samsa-bundle-tools-style";
    style.textContent = `
      .samsa-bundle-search { margin-bottom: 24px; }
      .samsa-bundle-search input {
        width: 100%;
        min-height: 48px;
        padding: 12px 16px;
        border: 1px solid #849675;
        border-radius: 8px;
        background: white;
        color: #222;
        font: inherit;
        box-sizing: border-box;
      }
      .samsa-bundle-search input:focus {
        outline: 2px solid rgba(132,150,117,.3);
      }
      .samsa-bundle-empty {
        display: none;
        padding: 18px;
        text-align: center;
      }
    `;
    document.head.appendChild(style);
  }

  let pending = false;

  function refresh() {
    if (pending) return;

    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      addStyles();
      addSearch();
      formatPrices();
      translateBundleFooter();
    });
  }

  new MutationObserver(refresh).observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();
